var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9,
  height: 18,
  fill: "none",
  viewBox: "0 0 9 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.115 7.808a2 2 0 0 1 0 2.384l-4.51 6.075C2.458 17.814 0 17.002 0 15.075V2.925C0 .998 2.457.186 3.606 1.733z"
})));
export { SvgRightWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDkgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjExNTExIDcuODA3OTJDOC42NDA1NiA4LjUxNTc5IDguNjQwNTYgOS40ODQyMSA4LjExNTExIDEwLjE5MjFMMy42MDU5MSAxNi4yNjY3QzIuNDU3MzIgMTcuODE0IDIuNjIzNjdlLTA3IDE3LjAwMTYgMi4zOTM4N2UtMDcgMTUuMDc0Nkw5LjQ1MDk4ZS0wOCAyLjkyNTQzQzcuMTUzMDFlLTA4IDAuOTk4MzkzIDIuNDU3MzIgMC4xODYwMjYgMy42MDU5MSAxLjczMzM1TDguMTE1MTEgNy44MDc5MloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";